// extracted by mini-css-extract-plugin
module.exports = {"medium":"1024px","large":"1280px","is-sticky":"SearchHeader_is-sticky__vNMHj","fromTop":"SearchHeader_fromTop__3A7h_"};